var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#00374F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7167 9.51667L14.4833 10.2833L6.93333 17.8333H6.16667V17.0667L13.7167 9.51667ZM16.7167 4.5C16.5083 4.5 16.2917 4.58333 16.1333 4.74167L14.6083 6.26667L17.7333 9.39167L19.2583 7.86667C19.5833 7.54167 19.5833 7.01667 19.2583 6.69167L17.3083 4.74167C17.1417 4.575 16.9333 4.5 16.7167 4.5ZM13.7167 7.15833L4.5 16.375V19.5H7.625L16.8417 10.2833L13.7167 7.15833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.79c55cf11b31338803253fb92bdffc8f.svg";
export { ForwardRef as ReactComponent };